module.exports = __webpack_public_path__ + "static/media/machobanners_sm4.472ac87c.png";